import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { QuoteInfoTab } from '../../types/state/quote-line';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { QuoteLineParams } from './types';

type Params = QuoteLineParams & {
  tab: QuoteInfoTab;
};

export function quoteLineInfoTabChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  quoteLine.infoTab = action.payload.tab;
}
